__webpack_require__.p = "/dist/wp/";